import React from 'react'
import { LoadingMaskSquare } from './loading-mask-square'

export function LoadingMaskGradeBadgeLarge() {
  return <LoadingMaskSquare size={80} borderRadius={5} colorValue="darker" />
}

export function LoadingMaskGradeBadgeSmall({
  className
}: {
  readonly className?: string
}) {
  return (
    <LoadingMaskSquare
      size={24}
      borderRadius={2}
      colorValue="lighter"
      className={className}
    />
  )
}
